import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formattedDate } from "../NetworkPortal/PayOut/helper";
import { getNetworkMenuId } from "../../Utils/types";
import {
  GetInsurerPayoutCountsNetwork,
  GetTotalBillingDataAction,
} from "../../redux/actions/InsBillAction";

export const TotalBilling = ({
  setSwitchTab,
  searchFilter,
  setProviderDetail,
  setMonth,
  setSearchFilter,
  downloadFile,
  isLoadingExcel,
}) => {
  const dispatch = useDispatch();
  const payoutReducer = useSelector((state) => state?.PayoutReducer);
  const globalReducer = useSelector((state) => state?.globalReducer);
  const insBillReducer = useSelector((state) => state?.InsBillingPayout);
  
  useEffect(() => {
    dispatch(GetTotalBillingDataAction({...searchFilter, page: 1, rows: 10,}));
  }, []);

  return (
    <>
      <div className="table-responsive __custom__properties">
        <table className="table">
          <thead>
            <tr className="avanishtbl">
              <th>Month</th>
              <th style={{ textAlign: "center" }}>Closed Cases</th>
              <th style={{ textAlign: "center" }}>Insurer Amount</th>
              <th style={{ textAlign: "center" }}>GST</th>
              <th style={{ textAlign: "center" }}>Gross Amount</th>
              <th style={{ textAlign: "center" }}>Status</th>
              <th style={{ textAlign: "center" }}>Action</th>
              <th style={{ textAlign: "center" }}>Export</th>
            </tr>
          </thead>
          {insBillReducer?.getTotalBilling?.length !== 0 && (
            <tbody>
              {insBillReducer?.getTotalBilling?.map((ele, index) => {
                return (
                  <tr>
                    <td>
                      <a
                        className="text-highlighted text-decoration"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setSwitchTab("totalClient");
                          setMonth(
                            new Date(
                              ele?.appointmentClosedDate.split("T")[0]
                            ).getMonth() + 1
                          );
                          setSearchFilter({
                            ...searchFilter,
                            month: ele?.month,
                          });
                          dispatch(
                            GetInsurerPayoutCountsNetwork({
                              ...searchFilter,
                              month: ele?.month,
                            })
                          );
                        }}
                      >
                        {formattedDate(ele?.appointmentClosedDate)}
                      </a>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {ele?.totalAppointments?.toLocaleString('en-IN')}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {ele?.insurerPayoutAmount?.toLocaleString('en-IN')}
                    </td>
                    <td style={{ textAlign: "center" }}>{ele?.gst?.toLocaleString('en-IN')}</td>
                    <td style={{ textAlign: "center" }}>{ele?.netAmount?.toLocaleString('en-IN')}</td>
                    <td>
                      <p
                        style={{ margin: "auto" }}
                        className={`status-style ${
                          ele?.status === "Paid" 
                            ? "approved"
                            : ele?.status === "Pending At Finance" 
                            ? "pendingAtFinance"
                            : ele?.status === "Pending For Payment"
                            ? "pendingForpayment"
                            : "pending"
                        }`}
                      >
                        {" "}
                        {ele?.status}
                      </p>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <button
                        className="btn search__btn action_export"
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#sendToQcModal"
                        disabled={
                          getNetworkMenuId()?.canEdit === false
                            ? true
                            : ele?.isInsurerPayoutStatus === false
                            ? true
                            : (ele?.status !== "Pending At Finance") === true
                            ? true
                            : false
                        }
                        onClick={() => setProviderDetail([ele])}
                      >
                        QC Approval &nbsp;
                        <i class="fa-solid fa-caret-right"></i>
                      </button>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <button
                        className="btn search__btn action_export"
                        type="button"
                        disabled={isLoadingExcel}
                        onClick={() => {
                          downloadFile(ele);
                        }}
                      >
                        <i className="fa-solid fa-file-csv"></i>&nbsp;
                        {isLoadingExcel ? "Exporting..." : "Export"}
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          )}
        </table>
        {payoutReducer?.getTotalBilling?.length === 0 && (
          <p className="noRecordFound">No Record Found</p>
        )}
      </div>
    </>
  );
};
